import api from '../../utils/api'

import { useEffect, useState } from 'react'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormAviamento from './form/FormAviamento'

function EditAviamento({ id, btCancelAction, handleOnSuccess }) {
    const [aviamento, setAviamento] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {

        api.get(`/aviamento/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {

            setAviamento(response.data.aviamento)
        })
    }, [token, id])

    async function updateAviamento(aviamento) {
        let msgType = 'success'


        const data = await api.patch(`aviamento/${aviamento._id}`, aviamento, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            handleOnSuccess()
        }

    }


    return (
        aviamento.name && (
            <FormAviamento title="Editar Aviamento" handleSubmit={updateAviamento} btnText="Salvar" btCancelAction={btCancelAction} aviamentoData={aviamento} />
        )
    )
}

export default EditAviamento
